$(document).ready(function(){

  $('.c-toggle').each(function(){
    var toggle = $(this);
    var label = toggle.find('.c-toggle__label');
    label.click(function(){
      toggle.toggleClass('c-toggle--open');
    });
  });

});